const extractLevelParts = (value) => {
  const matches = String(value ?? '').match(/\d+(?:\.\d+)?/g);
  if (!matches) return [];

  return matches
    .map((part) => Number(part))
    .filter((part) => Number.isFinite(part));
};

export const getHighestCharacterLevel = (value, fallback = 0) => {
  const parts = extractLevelParts(value);
  if (!parts.length) return fallback;
  return Math.max(...parts);
};

export const getTotalCharacterLevels = (value, fallback = 0) => {
  const parts = extractLevelParts(value);
  if (!parts.length) return fallback;
  return parts.reduce((sum, part) => sum + part, 0);
};

export const getCharacterLevelParts = (value) => extractLevelParts(value);
